var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lao-content",attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"page","mode":"out-in"},on:{"after-enter":_vm.refreshLandingAnimations}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1),_c('ConfirmDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }